export const ASSET_RESOLUTION_OPTIONS = [
  { value: "hdpi", label: "hdpi" },
  { value: "mdpi", label: "mdpi" },
  { value: "xhdpi", label: "xhdpi" },
  { value: "xxhdpi", label: "xxhdpi" },
  { value: "xxxhdpi", label: "xxxhdpi" },
];

export const formControlSx = {
  width: "100%",
  maxWidth: { xs: "100%", md: 360 },
};

export const fileInputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: 8,
  border: "1px solid rgba(0,0,0,0.42)",
  borderRadius: 4,
};

export const assetPreviewMediaSx = {
  display: "block",
  width: 220,
  height: 140,
  objectFit: "contain",
  border: "1px solid rgba(0, 0, 0, 0.12)",
  borderRadius: 1,
  bgcolor: "action.hover",
};
